const ARROW_LEFT = ['return', 'back'];
const MESSAGING = ['message'];
const EDIT = ['edit'];
const READ = ['read'];
const ADD = ['add'];

export { ARROW_LEFT, MESSAGING, EDIT, READ, ADD };
